function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { posActions } from '../../../reducers/pos.reducer';
import Button from '../../common/Button.react';
import Input from '../../common/form/Input.react';
import Label from '../../common/form/Label.react';
import Select from '../../common/form/Select.react';
import ModalHeader from '../../modal/ModalHeader.react';

// TODO :: Stop if app is not in constants
// TODO :: format internalUrl
var PosPagesAdd = function PosPagesAdd(_ref) {
  var app = _ref.app,
    pagesAction = _ref.pagesAction;
  var _useState = useState({
      app: app,
      title: '',
      internalUrl: '',
      type: 'article-page',
      topNavBar: true,
      articleType: 'default'
    }),
    _useState2 = _slicedToArray(_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  var articleTypesArr = useSelector(function (s) {
    return s.settings.constants.articleTypes || [];
  });
  var title = form.title,
    internalUrl = form.internalUrl,
    type = form.type,
    articleType = form.articleType;
  var isValid = function isValid() {
    return title.length > 0 && internalUrl.length > 0 && internalUrl.charAt(0) === '/';
  };
  var updateForm = function updateForm(key, value) {
    return setForm(_objectSpread(_objectSpread({}, form), {}, _defineProperty({}, key, value)));
  };
  var pageTypes = [{
    type: 'article-page',
    label: 'Article Page'
  }, {
    type: 'react-component',
    label: 'Custom React Component'
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: "Add Page"
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body"
  }, /*#__PURE__*/React.createElement(Label, {
    label: "Title",
    required: true,
    info: "Page Title. This will not be published, but is used to organize your application's pages"
  }), /*#__PURE__*/React.createElement(Input, {
    value: title,
    onChange: function onChange(e) {
      return updateForm('title', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "URL",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: internalUrl,
    onChange: function onChange(e) {
      return updateForm('internalUrl', e.target.value.replace(/ /g, '').replace(/[^a-z/-]/g, ''));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Page Type",
    required: true
  }), /*#__PURE__*/React.createElement(Select, {
    value: type,
    options: pageTypes.map(function (x) {
      return {
        sValue: x.type,
        sLabel: x.label
      };
    }),
    onChange: function onChange(_ref2) {
      var sValue = _ref2.sValue;
      return updateForm('type', sValue);
    }
  }), type === 'article-page' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    label: "Default Article Type",
    required: true
  }), /*#__PURE__*/React.createElement(Select, {
    value: articleType,
    options: articleTypesArr.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    }).map(function (x) {
      return {
        sValue: x.value,
        sLabel: x.description
      };
    }),
    onChange: function onChange(_ref3) {
      var sValue = _ref3.sValue;
      return updateForm('articleType', sValue);
    }
  })), /*#__PURE__*/React.createElement(Button, {
    label: 'Add',
    onClick: function onClick() {
      pagesAction({
        formData: form,
        method: 'post'
      });
    },
    width: "120px",
    disabled: !isValid()
  })));
};
var mdtp = {
  pagesAction: posActions.pages
};
export default connect(null, mdtp)(PosPagesAdd);